import styled, { css } from 'styled-components';

import { theme } from '@styles/theme';

export const User = styled.div`
  padding: 20px;
  flex: 1;
`;

export const Applied = styled.div`
  color: #9e9e9e;
`;

export const Attachment = styled.div`
  background-color: rgba(61, 64, 102, 0.05);
  border-radius: 4px;
  padding: 10px;
  display: flex;
  align-items: center;
  font-weight: bold;
  max-width: 280px;
  letter-spacing: 0.5px;
  opacity: 0.8;
  :hover {
    background-color: ${(p) => p.theme.colors.purpleTrans10};
  }
  svg:nth-child(1) {
    margin-right: 14px;
  }
  > div {
    > span {
      color: ${(p) => p.theme.colors.purple100};
      font-size: 12px;
    }
  }
`;

export const ApplicationReviewContainer = styled.div`
  ${(p) => p.topBorder && 'border-top: 1px solid rgba(60, 60, 100, 0.1)'};
  border-bottom: 1px solid rgba(60, 60, 100, 0.1);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 0;
  width: 100%;
`;

export const ApplicationReviewVote = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
`;

export const YourReviewContainer = styled.div`
  align-items: center;
  display: flex;
  margin-bottom: 20px;

  @media (max-width: ${(p) => p.theme.bp.md}) {
    display: block;
    > button {
      margin-bottom: 12px;
    }

    > button:nth-child(2),
    > button:nth-child(4) {
      margin-right: 0;
    }
  }
`;

export const ThumbContainer = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  font-size: 12px;
  font-weight: 600;
  font-size: 14px;
  line-height: 16px;
  & > svg {
    width: 24px;
    color: ${theme.color.purple80};
  }
  > span {
    text-align: center;
    width: calc(100% - 48px);
  }
`;

const thumbActiveRule = css`
  ${(p) =>
    p.thumb === 'S' &&
    css`
      background-color: ${theme.color.green100};
      color: ${theme.color.purple100};
    `};
  ${(p) =>
    p.thumb === 'Y' &&
    css`
      background-color: ${theme.color.green80};
      color: ${theme.color.purple100};
    `};
  ${(p) =>
    p.thumb === 'N' &&
    css`
      background-color: ${theme.color.orange80};
      color: ${theme.color.purple100};
    `};
  ${(p) =>
    p.thumb === 'D' &&
    css`
      background-color: ${theme.color.red100};
      color: ${theme.color.white100};
    `};
`;

export const ThumbButton = styled.button`
  height: 40px;
  width: 100%;
  max-width: 205px;
  min-width: 135px;
  color: ${theme.color.purple80};
  background-color: ${(p) => p.theme.purpleTrans5};
  border-radius: 4px;
  margin-right: ${(p) => (p.noMargin ? '0' : '16px')};
  transition: all 0.15s ease-out;
  ${(p) => p.active && thumbActiveRule};
  ${(p) =>
    !p.disabled &&
    css`
      :hover {
        cursor: pointer;
        ${thumbActiveRule};
      }
    `};

  @media (max-width: ${(p) => p.theme.bp.md}) {
    max-width: calc(50% - 10px);
    width: 100%;
  }
  @media (max-width: 480px) {
    max-width: 100%;
    display: block;
    margin-bottom: 10px;
  }
`;

export const FixedThumbButton = styled(ThumbButton)`
  width: 205px;
  @media (max-width: ${(p) => p.theme.bp.md}) {
    width: 205px;
    max-width: 100%;
  }
  @media (max-width: 480px) {
    width: auto;
    margin-bottom: 0;
  }
`;

export const NoContent = styled.div`
  color: ${(p) => p.theme.purple60};
  font-size: 16px;
`;

export const NoteEditButtons = styled.div`
  position: absolute;
  right: 16px;
  bottom: 16px;
  z-index: 9;
  display: flex;

  > button:nth-child(1) {
    margin-right: 8px;
  }
`;

export const GDPRApplicationWrapper = styled.div`
  width: 100%;
  background-color: #fff;
  height: ${(p) => p.ht};
  border-radius: 4px;
  padding: 40px;

  img {
    height: 90px;
    width: 90px;

    margin-right: 40px;
  }

  > div:nth-child(1) {
    display: flex;
    margin-bottom: 80px;
  }

  h2 {
    margin: 0;
    color: #6b6b6b;
    font-size: 28px;
    line-height: 40px;
  }

  p {
    color: #8c9cb0;
    font-size: 18px;
    line-height: 24px;
    margin: 0;
    max-width: 70%;
  }

  .fake-text {
    display: flex;
    flex-direction: column;
    div {
      height: 30px;
      border-radius: 4px;
      background-color: ${(p) => p.theme.colors.purple60};
      margin-bottom: 10px;
    }
    div:nth-child(4) {
      width: 60%;
      margin-bottom: 50px;
    }

    div:nth-child(5) {
      align-self: flex-end;
      width: 35%;
    }
    div:nth-child(6) {
      align-self: flex-end;
      width: 40%;
    }
  }
`;
